import { render, staticRenderFns } from "./modalAlert.vue?vue&type=template&id=2a188fb0&scoped=true"
import script from "./modalAlert.vue?vue&type=script&lang=js"
export * from "./modalAlert.vue?vue&type=script&lang=js"
import style0 from "./modalAlert.vue?vue&type=style&index=0&id=2a188fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a188fb0",
  null
  
)

export default component.exports